import { PlayerColor } from '@colonist/game-states';
import { Avatar } from '../../../../common/Avatar/index.ts';
import styles from './AvatarList.module.scss';
import React from 'react';
import { clsx } from 'clsx';
import { T, Tooltip } from '@colonist/ui';
export const AvatarList = ({ playerUserStates, currentPlayerPerspective, onChangePerspective })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.avatarContainer
    }, playerUserStates.map((player, index)=>/*#__PURE__*/ React.createElement(Tooltip, {
            content: /*#__PURE__*/ React.createElement(T, {
                id: {
                    key: 'strings:game.tooltips.replay.changePerspective',
                    options: {
                        playerColor: PlayerColor[player.selectedColor]
                    }
                }
            }),
            delay: 0,
            key: player.selectedColor,
            menuClassName: styles.tooltipMenu,
            position: "bottom"
        }, /*#__PURE__*/ React.createElement(Avatar, {
            className: clsx(styles.replayControlAvatar, {
                [styles.selected]: player.selectedColor === currentPlayerPerspective
            }),
            color: player.selectedColor,
            image: player.databaseIcon,
            onClick: ()=>onChangePerspective(player.selectedColor)
        }))));
